import Http from "../../common/utils/Http";

export const getPayCardList = async () => {
    try {
        return await Http.get('home/content/get');
    } catch (error) {
        throw error;
    }
}
